/**
 * Development (hosted) environment. Swapped in for `environment.ts` by the
 * `development` build configuration in `angular.json`.
 *
 * NOTE: the `loginUrl` host is an assumption (the shared login on the dev
 * subdomain) — confirm the real dev host before cutover.
 */
export const environment = {
  production: false,
  apiUrl: 'https://api.sisoma.dev',
  loginUrl: 'https://app.sisoma.dev/login',
  // Root of the legacy `users` app — the "Back to Halio" footer link opens it.
  usersAppUrl: 'https://app.sisoma.dev',
};
